import React, {Fragment, useState, useEffect} from "react";
import UsersTable from "root/Tables/UsersTable";
import './MyContributorsTab.scss';

import useModalAddUser from "root/Modals/AddUser/useModalAddUser";
import {suspendUser, reinstateUser, inviteAgain, getMyContributors} from "root/DataFunctions/UserDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {UserTypeFilters, UserTypeTitles} from "root/DataFunctions/Constants";
// import bootbox from "bootbox";
import useModalChangePassword from "root/Modals/ChangePassword/useModalChangePassword";
import {useParams} from "react-router";
import phpVars from 'phpVars';

const MyContributorsTab = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});
    const [userTypeName, setUserTypeName] = useState('');

    const [renderAddUserModal, showAddUserModal] = useModalAddUser((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const [renderChangePasswordModal, showChangePasswordModal] = useModalChangePassword(null, (result) =>
    {
        // do nothing
    })

    const {user_type} = useParams();
    const userFilter = user_type === undefined ? UserTypeFilters.MY_CONTRIBUTORS : user_type;

    useEffect(() => {
        getData();
    }, [userFilter]);

    const getData = () => {
        setUserTypeName(UserTypeTitles.MY_CONTRIBUTORS);

        getMyContributors(phpVars.user_id, (response) =>
        {
            setData({isLoading: false, data: getDataFromResponse(response)});
        });
    };

    const clickHandler = (user_id, mode, userTypeId, userTypeName) =>
    {
        switch (mode)
        {
            case 'create':
            case 'edit':
                showAddUserModal(user_id, mode, userTypeId, false);
                break;

            case 'suspend' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to suspend this user?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doSuspend(user_id);
                        }
                    })
                })
                break;

            case 'activate' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to activate this user?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doActivate(user_id);
                        }
                    })
                })
                break;

            case 'invite' :
                doInviteAgain(user_id);
                break;

            case 'password' :
                showChangePasswordModal(user_id);
                break;

            case 'stats' :
                showChangePasswordModal(user_id);
                break;
        }
    }

    const doSuspend = (user_id) =>
    {
        suspendUser(user_id, getData);
    }

    const doActivate = (user_id) =>
    {
        reinstateUser(user_id, getData);
    }

    const doInviteAgain = (user_id) =>
    {
        inviteAgain(user_id, confirmInvite);
    }

    const confirmInvite = () =>
    {
        bootbox.alert({
            size: "small",
            message: "A new invite has been sent to this user.",
            callback: function ()
            {
                getData();
            }
        })
    }

    const myUsersTable = () => {
        return (
            <Fragment>
                <div className="post-body">
                    <UsersTable loading={data.loading} data={data.data} clickHandler={clickHandler}/>
                </div>

                {renderAddUserModal(props)}
                {renderChangePasswordModal(props)}
            </Fragment>
        )
    }

    return (
        <Fragment>
            {myUsersTable()}
        </Fragment>
    )
}

MyContributorsTab.defaultProps = {};

export default MyContributorsTab;

